import { CompanyFilterBaseDataProvider } from './CompanyFilterBaseDataProvider';
import { GetTargetsRequest, GetTargetsResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { CompanyEndpointMethod } from '../../../quarantine/exchangeProtection/types';

export class CompanyFilterIntegrationsMarketplaceDataProvider extends CompanyFilterBaseDataProvider {
  async getInitialTargets(request: GetTargetsRequest): Promise<GetTargetsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'Company',
        method: CompanyEndpointMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          limit: 10,
          options: {
            source: 'fromIntegrationMarketplace',
          },
        },
      });

      const targets = response.data.map(({
         _id,
         name
      }) => ({
        companyId: _id,
        companyName: name,
      }));

      const userCompany = {
        companyId: this.dependencies.getUser().company.id,
        companyName: this.dependencies.getUser().company.name,
      };

      // Check if the targets array already contains the user company
      const exists = targets.some(target => target.companyId === userCompany.companyId);
      if (!exists) {
        targets.push(userCompany);
      }

      return {
        defaultTarget: [],
        targets: targets,
        totalCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getCompanies({
     companyName,
     page,
     limit,
     params,
   }: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    try {
      const options = {
        ...params,
        source: 'fromIntegrationMarketplace',
      };
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'Company',
        method: CompanyEndpointMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          options,
          companyName,
          limit: limit ?? 10,
          page,
        },
      });

      return {
        targets: response.data.map(({ _id, name }) => ({ companyId: _id, companyName: name })),
        totalCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
